import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

const GlobeIcon = ({ className }) => {
  const { colors } = useContext(ThemeContext);
  return (
    <svg
      className={className}
      viewBox="0 0 1204 1204"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M602,0 C270.9,0 0,270.9 0,602 C0,933.1 270.9,1204 602,1204 C933.1,1204 1204,933.1 1204,602 C1204,270.9 933.1,0 602,0 Z M605.117647,1139 C555.235294,1139 486.647059,1044.125 443,886 L761,886 C723.588235,1044.125 655,1139 605.117647,1139 Z M448.3,761 C443,723.05 443,678.775 443,634.5 C443,590.225 443,545.95 448.3,508 L755.7,508 C761,545.95 761,590.225 761,634.5 C761,678.775 761,723.05 755.7,761 L448.3,761 Z M128,634.5 C128,590.225 134.129032,545.95 146.387097,508 L318,508 C311.870968,545.95 311.870968,590.225 311.870968,634.5 C311.870968,678.775 311.870968,723.05 318,761 L146.387097,761 C134.129032,723.05 128,678.775 128,634.5 Z M602,125 C650.923077,125 718.192308,219.875 761,378 L443,378 C485.807692,219.875 553.076923,125 602,125 Z M886,508 L1057.6129,508 C1069.87097,545.95 1076,590.225 1076,634.5 C1076,678.775 1069.87097,723.05 1057.6129,761 L886,761 C892.129032,723.05 892.129032,678.775 892.129032,634.5 C892.129032,590.225 892.129032,545.95 886,508 Z M1014,380 L885.470588,380 C874.294118,308.75 851.941176,243.4375 824,190 C907.823529,231.5625 969.294118,296.875 1014,380 Z M380,190 C356.969697,243.4375 333.939394,308.75 322.424242,380 L190,380 C236.060606,296.875 299.393939,231.5625 380,190 Z M190,886 L318.529412,886 C329.705882,957.25 352.058824,1022.5625 380,1076 C296.176471,1034.4375 234.705882,969.125 190,886 Z M824,1076 C846.352941,1022.5625 868.705882,957.25 885.470588,886 L1014,886 C963.705882,969.125 902.235294,1034.4375 824,1076 Z"
          id="Shape"
          fill={colors.headingBlacker}
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

GlobeIcon.propTypes = {
  className: PropTypes.string
};

GlobeIcon.defaultProps = {
  className: undefined
};

export default GlobeIcon;
